import { render, staticRenderFns } from "./OsInputTextArea.vue?vue&type=template&id=58374402&scoped=true"
import script from "./OsInputTextArea.vue?vue&type=script&lang=ts"
export * from "./OsInputTextArea.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58374402",
  null
  
)

export default component.exports